import React, { useState } from 'react';
import { motion } from 'framer-motion';
import sedan from '../Assets/sedan.png'
import suv from '../Assets/Innova (1).png'
import hatchback from '../Assets/New-Suzuki-Dzire.jpg'

const VehicleTypes = () => {
  const [activeVehicle, setActiveVehicle] = useState(0);

  const vehicles = [
    {
      type: "HATCHBACK",
      description: "Enjoy the small & fast hatchback for your quick ride in the city",
      image: "https://honda-peringgit.com.my/wp-content/uploads/2024/06/honda-city-hatchback-2024-white-pearl.png" // Replace with your actual image
    },
    {
      type: "SEDAN",
      description: "Have larger luggage space to enjoy your comfortable ride",
      image: sedan // Replace with your actual image
    },
    {
      type: "SUV-MUV",
      description: "Perfectly trained driver with stylish fleet of cars at your disposal",
      image: suv // Replace with your actual image
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        
        {/* Header */}
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Vehicles For Every Budget
          </h1>
          <div className="w-24 h-1 bg-yellow-400 mx-auto"></div>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          
          {/* Left Content - Vehicle Selection */}
          <motion.div
            className="space-y-6"
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >
            {vehicles.map((vehicle, index) => (
              <motion.div
                key={vehicle.type}
                variants={itemVariants}
                className={`p-6 rounded-xl border-2 cursor-pointer transition-all duration-300 ${
                  activeVehicle === index
                    ? 'border-yellow-400 bg-yellow-50 shadow-lg'
                    : 'border-gray-200 bg-white hover:border-gray-300 hover:shadow-md'
                }`}
                onClick={() => setActiveVehicle(index)}
                whileHover={{ scale: 1.02 }}
              >
                <h3 className={`text-2xl font-bold mb-3 ${
                  activeVehicle === index ? 'text-yellow-400' : 'text-gray-800'
                }`}>
                  {vehicle.type}
                </h3>
                <p className={`text-lg leading-relaxed ${
                  activeVehicle === index ? 'text-gray-700' : 'text-gray-600'
                }`}>
                  {vehicle.description}
                </p>
              </motion.div>
            ))}
          </motion.div>

          {/* Right Content - Vehicle Image */}
          <motion.div
            className="relative"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-gradient-to-br from-gray-100 to-gray-200">
              {/* Placeholder for vehicle image - Replace with actual image */}
              {/* <div className="aspect-[4/3] flex items-center justify-center">
                <div className="text-center text-gray-600">
                  <div className="w-20 h-20 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                    </svg>
                  </div>
                  <p className="text-lg font-semibold">{vehicles[activeVehicle].type} Image</p>
                  <p className="text-sm mt-2">Replace with actual vehicle image</p>
                </div>
              </div> */}
              
              <img 
                src={vehicles[activeVehicle].image} 
                alt={vehicles[activeVehicle].type}
                className="w-full h-full object-cover"
              />
             
            </div>

            {/* Price Badge */}
            <motion.div
              className="absolute -bottom-4 -right-4 bg-yellow-400 text-gray-900 px-6 py-3 rounded-xl font-bold text-lg shadow-lg"
              initial={{ scale: 0 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              {activeVehicle === 0 && "From ₹10/km"}
              {activeVehicle === 1 && "From ₹15/km"}
              {activeVehicle === 2 && "From ₹20/km"}
            </motion.div>
          </motion.div>
        </div>

        {/* Additional Info */}
        {/* <motion.div
          className="mt-16 text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Safe & Secure</h4>
              <p className="text-gray-600 text-sm">GPS tracking and emergency support</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">On Time</h4>
              <p className="text-gray-600 text-sm">Punctual pickups and drop-offs</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mx-auto mb-3">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <h4 className="font-semibold text-gray-900 mb-2">Best Price</h4>
              <p className="text-gray-600 text-sm">Competitive rates with no hidden charges</p>
            </div>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default VehicleTypes;